// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const updateAccountLookup = (account) => ({
    accountLookup: account,
    type: actions.UPDATE_ACCOUNT_LOOKUP,
});

export const resetAccountLookup = () => ({
    type: actions.RESET_ACCOUNT_LOOKUP,
});
